module.exports = __webpack_public_path__ + "img/china_bc_icon.5e1afaf4.jpg";